import { LclWindowType } from 'typings/window';
import { getWindow, getWindowLocation } from 'utilities/window';
import {
  NielsenAPI,
  NielsenMetadata,
  NielsenQueue,
  NielsenSDK,
  NielsenTrackingEventType,
} from './config.nielsen.types';
import { messageLog } from './logger/message-logger';

const nielsenAPIOther: NielsenAPI = {
  // should always be last item
  pathname: [''],
  key: __NIELSEN_API_KEY_OTHER__,
  name: 'MetService.com',
};

const nielsenAPIKeys: NielsenAPI[] = [
  {
    pathname: ['/maps-radar'],
    key: __NIELSEN_API_KEY_MAPS_RADAR__,
    name: 'MetService.com - Maps & Radar',
  },
  {
    pathname: ['/mountains-and-parks'],
    key: __NIELSEN_API_KEY_MOUNTAINS__,
    name: 'MetService.com - Mountains & Parks',
  },
  {
    pathname: ['/$', '/national'],
    key: __NIELSEN_API_KEY_NATIONAL__,
    name: 'MetService.com - National',
  },
  {
    pathname: ['/towns-cities'],
    key: __NIELSEN_API_KEY_TOWNS_CITIES__,
    name: 'MetService.com - Towns & Cities',
  },
  {
    pathname: ['/marine'],
    key: __NIELSEN_API_KEY_MARINE__,
    name: 'MetService.com - Marine',
  },
  {
    pathname: ['/rural'],
    key: __NIELSEN_API_KEY_RURAL__,
    name: 'MetService.com - Rural',
  },
  {
    pathname: ['/warnings'],
    key: __NIELSEN_API_KEY_WARNINGS__,
    name: 'MetService.com - Warnings',
  },
  nielsenAPIOther,
];

const getPageApiKey = () => {
  for (let i = 0; i < nielsenAPIKeys.length; i++) {
    const nielsenApiKey = nielsenAPIKeys[i];

    for (let j = 0; j < nielsenApiKey.pathname.length; j++) {
      const pathname = nielsenApiKey.pathname[j];
      const regex = new RegExp('^' + pathname);

      // console.log('Nielsen API Key', {
      //   pathnameItem: pathname,
      //   browser: getWindowLocation().pathname,
      //   match: regex.test(getWindowLocation().pathname),
      // });

      if (regex.test(getWindowLocation().pathname)) {
        return nielsenApiKey;
      }
    }
  }
  return nielsenAPIOther;

  // const index = nielsenAPIKeys.findIndex(({ pathname: pathnames }) =>
  //   pathnames.some((path) => new RegExp(`^${path}`).test(`/${pathname.replace(/^\/*/, '')}`)),
  // );
  // const match = nielsenAPIKeys[index] ?? nielsenAPIOther;
  // return match;
};

export const nielsenInit = (): NielsenQueue => {
  const sdkInitInstance: LclWindowType['NOLBUNDLE'] = getWindow()?.NOLBUNDLE;
  let sdkInstance: NielsenSDK | undefined = undefined;
  let runningQueue = false;
  let currentMeta: { path: string; meta: NielsenMetadata } | undefined = undefined;
  const queue: NielsenMetadata[] = [];
  const log: [NielsenTrackingEventType, NielsenMetadata][] = [];

  const getQueue = () => queue;

  const clearQueue = async () => {
    runningQueue = true;
    while (queue.length > 0) {
      const lclSdk = sdkInstance;
      if (lclSdk) {
        if (currentMeta) {
          lclSdk.ggPM('staticend', currentMeta.meta);
          log.push(['staticend', currentMeta.meta]);
          currentMeta = undefined;
        }
        const message = queue.shift();
        if (message) {
          lclSdk.ggPM('staticstart', message);
          log.push(['staticstart', message]);
          if (__NIELSEN_SHOW_DEBUGGING__ === 'true') {
            const msg = log.map((l) => {
              const section = l[1] as NielsenMetadata;
              return [`${l[0]}:${section.section}`, l[1]] as [string, NielsenMetadata];
            });
            messageLog.ads('Nielsen Log', ...msg);
          }
          currentMeta = { path: getWindow()?.location.pathname ?? '', meta: message };
        }
      } else {
        messageLog.ads('Nielsen Err No SDK', ['err', queue]);
      }
    }
    runningQueue = false;
  };

  const set = ({ init }: { init?: boolean } = {}) => {
    const { key, name: section } = getPageApiKey();
    const brand = key.split('/')[0];

    const metaData: NielsenMetadata = {
      type: 'static',
      assetid: getWindow()?.location.pathname ?? '',
      section,
      subbrand: brand,
      pageURL: 'page_' + getWindow()?.location,
    };

    if (init) {
      /** We only add pageUrl when there is an spa navigation i.e. not on first load */
      delete metaData.pageURL;
    }

    queue.push(metaData);

    if (!runningQueue) {
      clearQueue();
    }
  };

  const getLog = () => log;

  /** Initialise */
  if (sdkInitInstance) {
    const { key } = getPageApiKey();
    sdkInstance = sdkInitInstance.nlsQ(key.split('/')[1], 'sdkInstance', {
      // nol_sdkDebug: __NIELSEN_SHOW_DEBUGGING__ === 'true' ? 'DEBUG' : '',
    });
    set({ init: true });
  }

  return { getQueue, set, getLog };
};
